var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"__picture"},[_c('img',{staticClass:"__image",attrs:{"src":_vm.url,"width":_vm.width}}),(_vm.desc.length > 1)?_c('div',{staticClass:"desc"},[_vm._v(_vm._s(_vm.desc))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }